import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "formulario" }
const _hoisted_2 = { class: "container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl" }
const _hoisted_3 = { class: "font-bold text-center text-2xl" }
const _hoisted_4 = { class: "font-bold text-center text-xl" }
const _hoisted_5 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_6 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_7 = { class: "block mb-1" }
const _hoisted_8 = { class: "text-sm text-red-500 p-error" }
const _hoisted_9 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_10 = { class: "block mb-1" }
const _hoisted_11 = { class: "text-sm text-red-500 p-error" }
const _hoisted_12 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_13 = { class: "block mb-1" }
const _hoisted_14 = { class: "text-sm text-red-500 p-error" }
const _hoisted_15 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4" }
const _hoisted_16 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_17 = { class: "block mb-1" }
const _hoisted_18 = { class: "text-sm text-red-500 p-error" }
const _hoisted_19 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_20 = { class: "block mb-1" }
const _hoisted_21 = { class: "text-sm text-red-500 p-error" }
const _hoisted_22 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_23 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_24 = { class: "block mb-1" }
const _hoisted_25 = { class: "w-full px-2 md:w-2/12" }
const _hoisted_26 = { class: "block mb-1" }
const _hoisted_27 = { class: "w-full px-2 md:w-3/12" }
const _hoisted_28 = { class: "block mb-1" }
const _hoisted_29 = { class: "text-sm text-red-500 p-error" }
const _hoisted_30 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_31 = { class: "block mb-1" }
const _hoisted_32 = { class: "text-sm text-red-500 p-error" }
const _hoisted_33 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_34 = { class: "w-full px-2 md:w-4/12" }
const _hoisted_35 = { class: "block mb-1" }
const _hoisted_36 = { class: "text-sm text-red-500 p-error" }
const _hoisted_37 = {
  key: 0,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_38 = { class: "block mb-1" }
const _hoisted_39 = { class: "text-sm text-red-500 p-error" }
const _hoisted_40 = {
  key: 1,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_41 = { class: "block mb-1" }
const _hoisted_42 = { class: "text-sm text-red-500 p-error" }
const _hoisted_43 = {
  key: 2,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_44 = { class: "block mb-1" }
const _hoisted_45 = { class: "text-sm text-red-500 p-error" }
const _hoisted_46 = {
  key: 3,
  class: "w-full px-2 md:w-4/12"
}
const _hoisted_47 = { class: "block mb-1" }
const _hoisted_48 = { class: "text-sm text-red-500 p-error" }
const _hoisted_49 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3" }
const _hoisted_50 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_51 = { class: "block mb-1" }
const _hoisted_52 = { class: "text-sm text-red-500 p-error" }
const _hoisted_53 = { class: "w-full px-2 md:w-6/12" }
const _hoisted_54 = { class: "block mb-1" }
const _hoisted_55 = { class: "text-sm text-red-500 p-error" }
const _hoisted_56 = { class: "flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5" }
const _hoisted_57 = { class: "w-full px-2 flex flex-row gap-2" }
const _hoisted_58 = {
  for: "recibirNotificaciones",
  class: "cursor-pointer"
}
const _hoisted_59 = { class: "flex flex-wrap py-2 mt-3 jusi" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { class: "pi pi-spin pi-spinner mr-2" }
const _hoisted_62 = { class: "pi pi-check mr-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderSection = _resolveComponent("HeaderSection")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Select = _resolveComponent("Select")!
  const _component_ToggleSwitch = _resolveComponent("ToggleSwitch")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_HeaderSection),
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.onSubmit,
        "validation-schema": _ctx.schema,
        class: "space-y-4 text-gray-700 mx-5",
        onInvalidSubmit: _ctx.onInvalidSubmit
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t('titulo.acreditacion.invitados')), 1),
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('label.complete.el.form')), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('label.documento')), 1),
                _createVNode(_component_Field, {
                  name: "dni",
                  modelValue: _ctx.formData.dni,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.dni) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      placeholder: _ctx.$t('label.documento'),
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(_component_ErrorMessage, { name: "dni" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('label.nombre')), 1),
                _createVNode(_component_Field, {
                  name: "nombre",
                  modelValue: _ctx.formData.nombre,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.nombre) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.nombre')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_ErrorMessage, { name: "nombre" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('label.apellido')), 1),
                _createVNode(_component_Field, {
                  name: "apellido",
                  modelValue: _ctx.formData.apellido,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.apellido) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.apellido')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_ErrorMessage, { name: "apellido" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('label.empresa')), 1),
                _createVNode(_component_Field, {
                  name: "empresa",
                  modelValue: _ctx.formData.empresa,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.empresa) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.empresa')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_ErrorMessage, { name: "empresa" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('label.cargo')), 1),
                _createVNode(_component_Field, {
                  name: "cargo",
                  modelValue: _ctx.formData.cargo,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.cargo) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.cargo')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_ErrorMessage, { name: "cargo" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('label.pais')), 1),
                _createVNode(_component_Select, {
                  modelValue: _ctx.selectedCountry,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCountry) = $event)),
                  options: _ctx.translatedCountries,
                  optionLabel: "value",
                  placeholder: _ctx.$t('label.pais'),
                  class: "input-base"
                }, null, 8, ["modelValue", "options", "placeholder"])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('label.codigo.pais')), 1),
                (_ctx.selectedCountry !== null)
                  ? (_openBlock(), _createBlock(_component_InputText, {
                      key: 0,
                      type: "text",
                      modelValue: _ctx.selectedCountry.code,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCountry.code) = $event)),
                      class: "input-base",
                      readonly: ""
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('label.codigo.area')), 1),
                _createVNode(_component_Field, {
                  name: "codigoArea",
                  modelValue: _ctx.formData.codigoArea,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.codigoArea) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.codigo.area')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_29, [
                      _createVNode(_component_ErrorMessage, { name: "codigoArea" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('label.celular')), 1),
                _createVNode(_component_Field, {
                  name: "numeroTelefono",
                  modelValue: _ctx.formData.numeroTelefono,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.numeroTelefono) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.celular')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_32, [
                      _createVNode(_component_ErrorMessage, { name: "numeroTelefono" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('label.pais.residencia')), 1),
                _createVNode(_component_Field, {
                  name: "paisDomicilio",
                  modelValue: _ctx.formData.paisDomicilio,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.paisDomicilio) = $event))
                }, {
                  default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                    _createVNode(_component_Select, {
                      filter: "",
                      onBlur: handleBlur,
                      "onUpdate:modelValue": handleChange,
                      "model-value": value,
                      class: _normalizeClass([{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }, "input-base"]),
                      placeholder: "País",
                      options: _ctx.translatedResidenceCountries,
                      optionLabel: "value"
                    }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "class", "options"]),
                    _createElementVNode("span", _hoisted_36, [
                      _createVNode(_component_ErrorMessage, { name: "paisDomicilio" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.formData.paisDomicilio?.code == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('label.provincia')), 1),
                    _createVNode(_component_Field, {
                      name: "provincia",
                      modelValue: _ctx.formData.provincia,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.provincia) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: _ctx.$t('label.seleccione.opcion'),
                          options: _ctx.provincias,
                          optionLabel: "descripcion",
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }])
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                        _createElementVNode("span", _hoisted_39, [
                          _createVNode(_component_ErrorMessage, { name: "provincia" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.code != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t('label.provincia')), 1),
                    _createVNode(_component_Field, {
                      name: "provinciaEstado",
                      modelValue: _ctx.formData.provinciaEstado,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.provinciaEstado) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su provincia o estado",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_42, [
                          _createVNode(_component_ErrorMessage, { name: "provinciaEstado" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.code == '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('label.localidad')), 1),
                    _createVNode(_component_Field, {
                      name: "localidad",
                      modelValue: _ctx.formData.localidad,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.localidad) = $event))
                    }, {
                      default: _withCtx(({ handleChange, handleBlur, value, errors }) => [
                        _createVNode(_component_Select, {
                          onBlur: handleBlur,
                          filter: "",
                          "onUpdate:modelValue": handleChange,
                          "model-value": value,
                          placeholder: _ctx.$t('label.seleccione.opcion'),
                          class: _normalizeClass(["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }]),
                          options: _ctx.localidades,
                          optionLabel: "descripcion"
                        }, null, 8, ["onBlur", "onUpdate:modelValue", "model-value", "placeholder", "options", "class"]),
                        _createElementVNode("span", _hoisted_45, [
                          _createVNode(_component_ErrorMessage, { name: "localidad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.formData.paisDomicilio?.code != '+54')
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('label.localidad')), 1),
                    _createVNode(_component_Field, {
                      name: "localidadCiudad",
                      modelValue: _ctx.formData.localidadCiudad,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.localidadCiudad) = $event))
                    }, {
                      default: _withCtx(({ field, errors }) => [
                        _createVNode(_component_InputText, _mergeProps(field, {
                          type: "text",
                          placeholder: "Ingrese su localidad o ciudad",
                          class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }]
                        }), null, 16, ["class"]),
                        _createElementVNode("span", _hoisted_48, [
                          _createVNode(_component_ErrorMessage, { name: "localidadCiudad" })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('label.mail')), 1),
                _createVNode(_component_Field, {
                  name: "mail",
                  modelValue: _ctx.formData.mail,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.mail) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "mail",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.mail')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_52, [
                      _createVNode(_component_ErrorMessage, { name: "mail" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _createElementVNode("label", _hoisted_54, _toDisplayString(_ctx.$t('label.rubro')), 1),
                _createVNode(_component_Field, {
                  name: "rubro",
                  modelValue: _ctx.formData.rubro,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.rubro) = $event))
                }, {
                  default: _withCtx(({ field, errors }) => [
                    _createVNode(_component_InputText, _mergeProps(field, {
                      type: "text",
                      class: ["input-base", { 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }],
                      placeholder: _ctx.$t('label.rubro')
                    }), null, 16, ["placeholder", "class"]),
                    _createElementVNode("span", _hoisted_55, [
                      _createVNode(_component_ErrorMessage, { name: "rubro" })
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_component_ToggleSwitch, {
                  modelValue: _ctx.formData.recibirNodedades,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.recibirNodedades) = $event)),
                  inputId: "recibirNotificaciones"
                }, null, 8, ["modelValue"]),
                _createElementVNode("label", _hoisted_58, _toDisplayString(_ctx.$t('label.acepto.recibir')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("button", {
                type: "submit",
                class: "mt-8 px-4 py-2 bg-transparent border-blue-950 hover:bg-cyan-600 text-blue-950 font-semibold hover:text-white border rounded",
                disabled: _ctx.isSubmitting
              }, [
                _withDirectives(_createElementVNode("i", _hoisted_61, null, 512), [
                  [_vShow, _ctx.isSubmitting]
                ]),
                _withDirectives(_createElementVNode("i", _hoisted_62, null, 512), [
                  [_vShow, !_ctx.isSubmitting]
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('boton.registrarme')), 1)
              ], 8, _hoisted_60)
            ])
          ]),
          _createVNode(_component_BlockUI, {
            blocked: _ctx.isSubmitting,
            fullScreen: ""
          }, null, 8, ["blocked"])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "onInvalidSubmit"])
    ])
  ], 64))
}